export function scrollTo() {
    const navItems = document.querySelectorAll(".cards-nav li a");
    const sections = document.querySelectorAll("[id^=\"test\"]");

    const removeActiveClasses = () => {
        document.querySelectorAll(".cards-nav li").forEach(item => {
            item.classList.remove("active");
        });
    };

    const addActiveClass = (targetId) => {
        const targetLink = document.querySelector(`.cards-nav li a[href="#${targetId}"]`);
        if (targetLink) {
            removeActiveClasses();
            targetLink.parentElement.classList.add("active");
        }
    };

    const smoothScrollTo = (targetId) => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const header = document.querySelector(".header");
            const headerHeight = header ? header.offsetHeight : 0;
            const targetPosition = targetElement.offsetTop - headerHeight - 20;
            
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth"
            });
        }
    };

    navItems.forEach(link => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = link.getAttribute("href").substring(1);
            
            addActiveClass(targetId);
            smoothScrollTo(targetId);
        });
    });

    const updateActiveOnScroll = () => {
        const scrollPosition = window.scrollY;
        const header = document.querySelector(".header");
        const headerHeight = header ? header.offsetHeight : 0;
        let activeSection = null;

        sections.forEach(section => {
            const sectionTop = section.offsetTop - headerHeight - 100;
            const sectionBottom = sectionTop + section.offsetHeight;
            
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                activeSection = section.id;
            }
        });

        if (activeSection) {
            addActiveClass(activeSection);
        } else {

            const firstSection = sections[0];
            if (firstSection && scrollPosition < firstSection.offsetTop - headerHeight - 100) {
                addActiveClass(firstSection.id);
            }
        }
    };

    let scrollTimeout;
    window.addEventListener("scroll", () => {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(updateActiveOnScroll, 10);
    });

    updateActiveOnScroll();
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollTo.js